module.exports = __webpack_public_path__ + "static/img/hover-bg.6266220.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/hover-bg.png
// module id = +PEv
// module chunks = 1